import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  width: '100%',
  maxWidth: '100%',
  height: '75vh',
  margin: '0 auto',
  alignItems: 'stretch',

  // Default: Side by side on larger screens
  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    alignItems: 'stretch'
  },

  [theme.breakpoints.up('md')]: {
    minHeight: '65vh'
  },

  [theme.breakpoints.up('lg')]: {
    minHeight: '70vh'
  },

  // Stack components on small screens
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column', // Stack form and results
    alignItems: 'center',     // Center the items
    justifyContent: 'center',
    width: '100%'
  }
}));
export const StyledForm = styled('form')(({ theme }) => ({
  width: '100%',
  minWidth: '280px',
  maxWidth: '600px',  // Prevents stretching too much
  padding: theme.spacing(2),
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  gap: theme.spacing(2),
  flex: 1,

  // On larger screens, form takes up 45% of the width
  [theme.breakpoints.up('sm')]: {
    width: '45%',
    padding: theme.spacing(2)
  },

  // On small screens, form takes up full width
  [theme.breakpoints.down('sm')]: {
    width: '100%'
  }
}));
export const StyledResults = styled(Box)(({ theme }) => ({
  width: '100%',
  minWidth: '300px',
  minHeight: '30vh',  // Ensures it has a proper minimum height
  maxHeight: '100%',  // Restricts height so scrolling works
  padding: theme.spacing(1),
  borderRadius: '0.5rem',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  flex: 1,
  overflow: 'hidden',  // Prevents double scrolling issues
  position: 'relative', // Needed for pseudo-element positioning

  // On larger screens, results take up 45% of the width
  [theme.breakpoints.up('sm')]: {
    width: '45%'
  },

  // On small screens, results take up full width
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    minHeight: 'auto' // Adjust height on small screens if needed
  }
}));
export const StyledScrollableBox = styled(Box)(({ theme }) => {
  return ({
    flex: 1,
    height: '100%', // Important: Ensures full height inside StyledResults
    maxHeight: 'calc(100vh - 20px)', // Adjusts for padding
    overflowY: 'auto',  // Enables scrolling
    overflowX: 'hidden',
    padding: '0.5rem',
    border: '1px solid #ddd',
    borderRadius: '0.25rem',

    '&::-webkit-scrollbar': {
      width: '6px'
    },
    scrollbarWidth: 'thin',
    scrollbarColor: '#aaa transparent'
  });
});
export const DropDownBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row', // Default: Horizontal
  gap: theme.spacing(2),
  justifyContent: 'center',
  paddingTop: theme.spacing(2),

  // Stack dropdowns vertically only on very small screens
  [theme.breakpoints.down('xs')]: {
    flexDirection: 'column',
    alignItems: 'center' // Ensures proper alignment
  }
}));
